import type { ResultOf, VariablesOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

export const FolderForm_Folder_Init_Mutation = graphql(`
  mutation FolderForm_Folder_Init(
    $folder: FolderInput!
    $versionData: VersionDataInput
  ) {
    initFolder(folder: $folder, versionData: $versionData) {
      _id
    }
  }
`);

export type FolderInput = VariablesOf<
  typeof FolderForm_Folder_Init_Mutation
>['folder'];

export type FolderForm_Folder_Init_Result = ResultOf<
  typeof FolderForm_Folder_Init_Mutation
>;

export const useInitFolderMutation = () =>
  useGraphQLMutation(FolderForm_Folder_Init_Mutation);
